import React from 'react';
import MyFlights from './MyFlights';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';
import cookies from 'utils/cookies';
import http from 'utils/http';
import moment from 'moment-timezone';
import { dateTolocale, dateToUTC, getLocatDate } from 'utils/converter';
import events from 'utils/evemts';
import airportTimezone from 'airport-timezone';
import ConfirmModalContainer from '../common/confirmModal/ConfirmModalContainer';
import AttachmentContainer from '../docArchive/tabs/attachment/AttachmentContainer';
import { cloneDeep } from 'lodash';
import { DateFormat, contractType } from 'custom/constants';

const station = cookies.get('station_code') || null;
class MyFlightsContainer extends React.Component {
  constructor(props) {
    super(props);
    const userContracts = cookies.get('contract_types') || Object.values(contractType);
    this.state = {
      modal: false,
      action: null,
      airline: [],
      flightData: [],
      flight: [],
      flightDetails: [],
      filteredData: [],
      showflightDetails: false,
      flightID: null,
      flightFields: {},
      flightErrors: {},
      searchFields: {
        from: moment(getLocatDate('YYYY-MM-DD HH:mm')).startOf('day').format('YYYY-MM-DD HH:mm'),
        to: moment(getLocatDate('YYYY-MM-DD HH:mm')).endOf('day').format('YYYY-MM-DD HH:mm'),
        contract_type: userContracts && userContracts[0] ? userContracts[0] : null
      },
      searchApplied: false,
      flightStatus: {
        arr: true,
        dept: true,
        submitted: true,
        airline: '',
        hideCompleted: false,
        no_op: true,
        pending: true,
        missing_ffm: false,
        manifest_uploaded: false,
        manual_updated_auto: false,
        updated_auto: false
      },
      // startDate: moment('2023-10-03 11:11:00', 'YYYY-MM-DD HH:mm:ss'),
      // endDate: moment('2023-10-04 10:10:00', 'YYYY-MM-DD HH:mm:ss'),
      // difference: {},
      flightList: [],
      locationList: [],
      scheduleOrgDest: {
        org: null,
        dest: null
      },
      showTableView: 'folder',
      anchorEl: null,
      filterAnchorEl: null,
      reportProps: {},
      userContractTypes: userContracts,
      contractTypesList: [],
      contractTypes: userContracts,
      showRejectedFlights: true,
      docs: [],
      docName: '',
      alert: [],
      loading: false,
      contractsLoading: {},
      expandedRows: {},
      viewSwitching: false
    };
    this.station_code = cookies.get('station_code') || null;
  }

  componentDidMount() {
    //call other functions after getFilters finishes
    Promise.resolve(this.getFilters()).then(() => {
      Promise.all([
        this.fetchUser(),
        this.fetchLocations(),
        this.fetchAirline(),
        this.fetchContractTypes()
      ]);
      // this.fetchFlights();
      // this.eventSource = events('admin', 'method');
      this.eventSource = events('flight');
      this.eventSource.onmessage = ({ type, data }) => {
        if (type == 'message') {
          const msg = JSON.parse(data || '{}');
          this.handleEvent(msg);
        }
      };
    });
  }

  componentWillUnmount() {
    this.eventSource && this.eventSource.close();
  }


  handleEvent = (msg) => {
    if (msg.action == 'add') {
      if (msg.data && (msg.data.org == station || msg.data.dest == station)) {
        // based on station get the date and time and add only if it is within the selected date range
        const from = dateToUTC(this.state.searchFields.from, 'YYYY-MM-DD HH:mm');
        const to = dateToUTC(this.state.searchFields.to, 'YYYY-MM-DD HH:mm');
        const date = msg.data.org == station ? msg.data.act_dept || msg.data.est_dept || msg.data.schdl_dept : msg.data.act_arr || msg.data.est_arr || msg.data.schdl_arr;
        const sch_date = msg.data.org == station ? msg.data.schdl_dept : msg.data.schdl_arr;
        if (moment(date).isBetween(from, to) || moment(sch_date).isBetween(from, to)) {
          this.setState((prev) => ({ flightList: [msg.data, ...prev.flightList] }), () => this.filterData());
        }
      }
    }
    if (this.state.flightList && this.state.flightList.length > 0) {
      if (msg.action == 'updates' || msg.action == 'update') {
        const stn_code = cookies.get('station_code');
        if (msg.data && (msg.data?.org == stn_code || msg.data?.dest == stn_code)) {
          const flightList = [...this.state.flightList];
          const index = flightList.findIndex(d => msg.data && d.id == msg.data.id);
          if (index > -1) {
            flightList[index] = {
              ...flightList[index],
              ...msg.data
            };
            this.setState({ flightList }, () => this.filterData());
          }
        }
      }
    }
    if (msg.action === 'delete') {
      if (this.state.flightList && this.state.flightList.length > 0) {
        const flightList = [...this.state.flightList];
        const index = flightList.findIndex(d => msg.data && d.id == msg.data.id);
        if (index > -1) {
          flightList.splice(index, 1);
          this.setState({ flightList }, () => this.filterData());
        }
      }
    }
  };

  // calculateDifference = () => {
  //   const { startDate, endDate } = this.state;
  //   let difference = {};

  //   // difference.hours = endDate.diff(startDate, 'hours');
  //   // difference.minutes = endDate.diff(startDate, 'minutes');
  //   let total  = endDate.diff(startDate, 'minutes'); // Get the difference in minutes
  //   difference.hours = Math.floor(total / 60); // Calculate hours
  //   difference.minutes = total % 60; 
  //   this.setState({ difference, });
  // };

  fetchUser = () => {
    return http.get(`/user?id=${cookies.get('user')}`, { headers: { hideloader: true } }).then(({ data }) => {
      if (data && data.data && data.data.length > 0) {
        const userContractTypes = data.data[0]?.contract_types || [];
        this.setState({ userContractTypes: userContractTypes.length > 0 ? userContractTypes : (cookies.get('contract_types') || Object.values(contractType)), }, () => {
          if (this.state.contractTypesList && this.state.contractTypesList.length > 0) {
            this.filterContractTypes();
          }
          this.fetchFlights();
        });
      }
    });
  };

  fetchLocations = () => {
    return http.get('/locations', { headers: { hideloader: true } })
      .then((response) => {
        const locationList = response.data.data.filter((item, index, self) =>
          self.findIndex((t) => t.iata_code === item.iata_code) === index
        );
        this.setState({ locationList: locationList });
      });
  };

  fetchAirline = () => {
    return http.get(`/airline?active=${true}`, { headers: { hideloader: true } })
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          this.setState({ airline: data.data });
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  fetchContractTypes = () => {
    let searchFields = this.state.searchFields;
    let from = searchFields.from;
    let to = searchFields.to;
    return http.get(`/check_contract?from=${from}&to=${to}`, { headers: { hideloader: true } })
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          this.setState({ contractTypesList: data.data }, () => this.filterContractTypes());
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  filterContractTypes = () => {
    let contractTypesList = this.state.contractTypesList || [];
    let contractTypes = [];
    contractTypesList.map((contract) => {
      if (this.state.flightStatus.airline === '') {
        contractTypes.push(contract.type);
      }
      if (this.state.flightStatus.airline === contract.airline?.code) {
        contractTypes.push(contract.type);
      }
    });
    const userTypes = (this.state.userContractTypes && this.state.userContractTypes.length > 0)
      ? this.state.userContractTypes
      : (cookies.get('contract_types') && cookies.get('contract_types').length > 0
        ? cookies.get('contract_types')
        : Object.values(contractType));

    if (userTypes && userTypes.length > 0) {
      contractTypes = contractTypes.filter((item) => userTypes.includes(item));
    }
    contractTypes = [...new Set(contractTypes)];
    if (contractTypes.length === 0 && userTypes && userTypes.length > 0) {
      contractTypes = userTypes;
    }

    const currentContractType = this.state.searchFields.contract_type;
    const selectedContractType = (currentContractType && contractTypes.includes(currentContractType))
      ? currentContractType
      : (contractTypes && contractTypes[0]) || null;

    this.setState({
      contractTypes: contractTypes,
      searchFields: {
        ...this.state.searchFields,
        contract_type: selectedContractType
      }
    }, () => {
      this.checkExpiringContracts();
      this.filterData();
    });
  };

  fetchFlights = (search = false) => {
    let searchFields = this.state.searchFields;
    console.log('searchFields', searchFields);
    let from = dateToUTC(moment(searchFields.from).format('YYYY-MM-DD')?.toString() + ' 00:00', 'YYYY-MM-DD HH:mm');
    let to = dateToUTC(moment(searchFields.to).format('YYYY-MM-DD')?.toString() + ' 23:59', 'YYYY-MM-DD HH:mm');
    // let from = dateToUTC(searchFields.from, 'YYYY-MM-DD HH:mm');
    // let to = dateToUTC(searchFields.to, 'YYYY-MM-DD HH:mm');
    let url = '/flights?';
    if (!search) {
      url += `from=${from}&`;
      url += `to=${to}&`;
    } else {
      url += `flight${searchFields.flight ? '=' + searchFields.flight?.toUpperCase() : ''}&from=${from}&to=${to}`;
    }
    url += `&station=${cookies.get('station_code')}`;
    url += `&hidecomp=${this.state.flightStatus.hideCompleted}`;
    url += `&contract_type=${this.state.searchFields.contract_type}`;
    url += `&submitted=${this.state.flightStatus.submitted}`;
    if (searchFields && searchFields.from && searchFields.to) {
      this.setState({ loading: true });
      http.get(url, { headers: { hideloader: true } }).then(({ data }) => {
        if (data?.data?.length > 0) {
          this.setState({
            flightList: data.data,
            search: search ? true : false,
            loading: false
          }, () => { this.filterData(search); });
        } else {
          this.setState({
            flightList: [],
            filteredData: [],
            loading: false
          });
        }
      })
        .catch(error => {
          console.error('Error fetching data:', error);
          this.setState({
            flightList: [],
            filteredData: [],
            loading: false
          });
        });
    }
  };

  handleRowExpand = (flightId, isExpanded) => {
    this.setState((prev) => ({
      expandedRows: {
        ...prev.expandedRows,
        [flightId]: isExpanded
      }
    }));
  };

  getFreport = (row) => {
    let report = row?.reports && row?.reports?.find((report) => report.type === this.state.searchFields.contract_type);
    let report_status = report?.status ? (report?.status.toLowerCase() === 'submitted' ? 'Report not submitted' : report?.status) : 'Not Finalized';
    if (row.contracts || report_status === 'Report not submitted') {
      //do nothing
    } else {
      if (this.state.contractsLoading[row.id]) return;
      this.setState((prev) => ({
        contractsLoading: {
          ...prev.contractsLoading,
          [row.id]: true
        }
      }));
      http.get(`/getfreport/${row.id}?only=contracts`, { headers: { hideloader: true } }).then(({ data }) => {
        let flightList = [...this.state.flightList];
        let index = flightList.findIndex(f => f.id === row.id);
        if (index > -1) {
          flightList[index] = {
            ...flightList[index],
            contracts: cloneDeep(data.data?.[0].contracts)
          };
          this.setState((prev) => ({
            flightList,
            contractsLoading: {
              ...prev.contractsLoading,
              [row.id]: false
            }
          }), () => { this.filterData(); });
        } else {
          this.setState((prev) => ({
            contractsLoading: {
              ...prev.contractsLoading,
              [row.id]: false
            }
          }));
        }
      }).catch(() => {
        this.setState((prev) => ({
          contractsLoading: {
            ...prev.contractsLoading,
            [row.id]: false
          }
        }));
      });
    }
  };

  onFilterMain = (e) => {
    console.log(e.target);
    let data = {};
    let name = e.target.name;
    let value = e.target.value;
    if (name == 'to') {
      let from = this.state.searchFields.from;
      let to = value;
      if (from > to) {
        data.from = to;
      }
    }
    if (name == 'from') {
      let from = value;
      let to = this.state.searchFields.to;
      if (from > to) {
        data.to = from;
      }
    }
    console.log('onFilterMain', name, value);
    this.setState((prev) => ({
      searchFields: {
        ...prev.searchFields,
        [name]: value,
        ...data
      }
    }), () => {
      console.log('onFilterMain', this.state.searchFields);
      if (name != 'flight' || (name == 'flight' && !value)) {
        let search = false;
        if (name == 'contract_type') {
          search = this.state.search;
          this.checkExpiringContracts();
        }
        this.storeFilters();
        if (name == 'from' || name == 'to') {
          this.fetchContractTypes();
        }
        this.fetchFlights(search);
      }
    });
  };

  onChange = (e, newvalue = null) => {
    const name = e.target.name ? e.target.name : e.target.id.split('-')[0];
    let value = newvalue?.iata_code ? newvalue.iata_code : e.target.value;
    let orgval = '';
    let destval = '';
    if (name == 'org' || name == 'dest') {
      if (name == 'org') {
        orgval = (this.state.flightFields.dest === cookies.get('station_code')) &&
          value === cookies.get('station_code') ? '' : value;
        destval = orgval === cookies.get('station_code') ? this.state.flightFields.dest : cookies.get('station_code');
      }
      if (name == 'dest') {
        destval = (this.state.flightFields.org === cookies.get('station_code')) &&
          value === cookies.get('station_code') ? '' : value;
        orgval = destval === cookies.get('station_code') ? this.state.flightFields.org : cookies.get('station_code');
      }
      this.setState({
        scheduleOrgDest: {
          org: this.state.locationList.filter(c => c.iata_code === orgval)[0],
          dest: this.state.locationList.filter(c => c.iata_code === destval)[0]
        },
        flightFields: {
          ...this.state.flightFields,
          ['org']: orgval,
          ['dest']: destval
        }
      }, () => {
        this.storeFilters();
      });
    } else {
      this.setState({
        flightFields: {
          ...this.state.flightFields,
          [name]: value
        }
      }, () => {
        this.storeFilters();
      });
    }
  };

  changeDateAndTime = (element, type) => {
    this.setState({
      flightFields: {
        ...this.state.flightFields,
        [type]: (type == 'sta_time' || type == 'std_time') ? element.target.value : element.format('YYYY-MM-DD')
      }
    });
  };

  checkExpiringContracts = () => {
    this.setState({ alert: [] });
    let contractType = this.state.searchFields.contract_type;
    if(!contractType) return;
    let tz = this.getTimeZone(cookies.get('station_code'));
    let from = moment.tz(tz).utc().format('YYYY-MM-DD HH:mm:ss');
    let to = moment.tz(tz).add(12, 'days').utc().format('YYYY-MM-DD HH:mm:ss');
    let contractTypesList = this.state.contractTypesList;
    let expiringContracts = contractTypesList.filter((contract) => {
      let end_date = moment(contract.end_date, 'YYYY-MM-DD HH:mm:ss');
      return end_date.isBetween(from, to) && contract.type === contractType;
    });

    if (expiringContracts.length > 0) {
      const alertContracts = expiringContracts.map((contract) => {
        return {
          code: contract?.airline?.code || '-',
          endDate: moment(contract.end_date).format(DateFormat).toUpperCase()
        };
      });
      this.setState({ alert: alertContracts });
      setTimeout(() => {
        this.setState({ alert: [] });
      }, 10000); // Hide the alert after 10 seconds
    }
  };

  addFlight = (e) => {
    e.preventDefault();
    const { flightFields } = this.state;
    let formdata = {
      airlineId: flightFields.airlineId,
      flight_no: flightFields.flight_no,
      flight_date: flightFields.flight_date,
      org: flightFields.org,
      dest: flightFields.dest,
      schdl_dept: flightFields.schdl_dept,
      schdl_arr: flightFields.schdl_arr,
      ac_type: flightFields.ac_type,
      platform: flightFields.platform
    };
    if (this.validation()) {
      http.post('/flight', formdata)
        .then(() => {
          this.setState((prev) => ({
            flightFields: {
              airlineId: '',
              flight_no: '',
              flight_date: '',
              org: '',
              dest: '',
              schdl_dept: '',
              schdl_arr: '',
              ac_type: '',
              platform: ''
            },
            modal: prev.modal === 'adhoc_flight' ? false : null
          }));
        });
    }
  };

  validation = () => {
    const flightFields = { ...this.state.flightFields };
    const error = {};
    let formValid = true;
    if (!flightFields.airlineId) {
      formValid = false;
      error.airlineId = true;
    }
    if (!flightFields.platform || (flightFields.platform.trim().length === 0)) {
      formValid = false;
      error.platform = true;
    }
    if (!flightFields.flight_no || (flightFields.flight_no.trim().length === 0)) {
      formValid = false;
      error.flight_no = true;
    }
    if (!flightFields.flight_date || (flightFields.flight_date.trim().length === 0)) {
      formValid = false;
      error.flight_date = true;
    }
    if (!flightFields.org || (flightFields.org.trim().length === 0)) {
      formValid = false;
      error.org = true;
    }
    if (!flightFields.dest || (flightFields.dest.trim().length === 0)) {
      formValid = false;
      error.dest = true;
    }
    if (!flightFields.ac_type || (flightFields.ac_type.trim().length === 0)) {
      formValid = false;
      error.ac_type = true;
    }
    if (!flightFields.schdl_dept || (flightFields.schdl_dept.trim().length === 0)) {
      formValid = false;
      error.schdl_dept = true;
    }
    if (!flightFields.schdl_arr || (flightFields.schdl_arr.trim().length === 0)) {
      formValid = false;
      error.schdl_arr = true;
    }
    this.setState({ flightErrors: error });
    return formValid;
  };


  editFlight = (e) => {
    e.preventDefault();
    const { flightFields } = this.state;
    let formdata = {
      airlineId: flightFields.airlineId,
      flight_no: flightFields.flight_no,
      flight_date: flightFields.flight_date,
      org: this.state.scheduleOrgDest.org.iata_code,
      dest: this.state.scheduleOrgDest.dest.iata_code,
      schdl_dept: moment(flightFields.schdl_dept).format('YYYY-MM-DD HH:mm'),
      schdl_arr: moment(flightFields.schdl_arr).format('YYYY-MM-DD HH:mm'),
      ac_type: flightFields.ac_type,
      platform: flightFields.platform
    };
    if (this.validation()) {
      http.put(`/flight/${flightFields.id}`, formdata)
        .then(() => {
          this.setState((prev) => ({
            flightFields: {
              airlineId: '',
              flight_no: '',
              flight_date: '',
              org: '',
              dest: '',
              schdl_dept: '',
              schdl_arr: '',
              ac_type: '',
              platform: ''
            },
            modal: prev.modal === 'adhoc_flight' ? false : null
          }));
        });
    }
  };

  deleteFlight = (id) => {
    http.delete('/flight/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete();
      }
    });
  };

  handleDelete = (id, anchorEl) => {
    // e.stopPropagation();
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteFlight(id),
    });
  };

  filterData = (search = false) => {
    const { flightList, flightStatus, searchFields, showRejectedFlights, contractTypesList, contractTypes } = this.state;
    if (!Array.isArray(flightList) || flightList.length === 0) {
      this.setState({
        filteredData: [],
        anchorEl: null 
      });
      return;
    }

    const {
      dept,
      arr,
      no_op,
      pending = true,
      missing_ffm,
      manifest_uploaded,
      manual_updated_auto,
      updated_auto,
      hideCompleted,
      submitted,
      airline
    } = flightStatus;

    const contractType = searchFields.contract_type;
    const stationCode = this.station_code || cookies.get('station_code');
    const fromStr = moment(searchFields.from).format('YYYY-MM-DD') + ' 00:00:00';
    const toStr = moment(searchFields.to).format('YYYY-MM-DD') + ' 23:59:59';

    // Fast indexed map for contract type date range check
    const validContractsByAirline = new Map();
    let hasMatchingContractType = false;
    if (contractType && Array.isArray(contractTypesList) && contractTypesList.length > 0) {
      for (let i = 0; i < contractTypesList.length; i++) {
        const c = contractTypesList[i];
        if (c.type === contractType && c.airlineId) {
          hasMatchingContractType = true;
          let list = validContractsByAirline.get(c.airlineId);
          if (!list) {
            list = [];
            validContractsByAirline.set(c.airlineId, list);
          }
          list.push({
            start: c.start_date ? c.start_date.split('T')[0].split(' ')[0] : '',
            end: c.end_date ? c.end_date.split('T')[0].split(' ')[0] : '',
            contractrows: c.contractrows
          });
        }
      }
    }

    let filteredData = [];

    for (let i = 0; i < flightList.length; i++) {
      const item = flightList[i];

      if (!search) {
        // 1. Dept filter
        if (!dept && item.org === stationCode) {
          continue;
        }

        // 2. Arr filter
        if (!arr && item.dest === stationCode) {
          continue;
        }

        // 3. Status filters (Show Finalized, Show Rejected, Show No Ops, Show Pending)
        const isNoOp = Boolean(item.no_op === true);
        const rep = item.reports && item.reports.find((r) => (!contractType || r.type === contractType));
        const isRejected = !isNoOp && Boolean(rep ? rep.status === 'Rejected' : (item.reports ? item.reports.find((r) => r.status === 'Rejected' && (!contractType || r.type === contractType)) : false));
        const isFinalized = !isNoOp && !isRejected && Boolean(rep && (
          rep.status === 'Finalized' ||
          rep.status === 'Approved' ||
          rep.approved_acc ||
          rep.approved_air
        ));
        const isPending = !isNoOp && !isRejected && !isFinalized;

        if (isNoOp && !no_op) {
          continue;
        }
        if (isRejected && !showRejectedFlights) {
          continue;
        }
        if (isFinalized && !submitted) {
          continue;
        }
        if (isPending && !pending) {
          continue;
        }

        // 4. Missing FFM filter
        if (missing_ffm) {
          const isMissing = (stationCode === item.dest && !item.in_ffm) || (stationCode === item.org && !item.out_ffm);
          if (!isMissing) continue;
        }

        // 5. Manifest uploaded filter
        if (manifest_uploaded) {
          const isUploaded = (stationCode === item.dest && item.in_ffm) || (stationCode === item.org && item.out_ffm);
          if (!isUploaded) continue;
        }

        // 6. Manual updated auto filter
        if (manual_updated_auto && (!item.reports || item.reports.length === 0)) {
          continue;
        }

        // 7. Auto updated (Manual entries required) filter
        if (updated_auto) {
          if (!contractType) continue;
          const autoRep = item.reports && item.reports.find((r) => r.type === contractType);
          if (autoRep && ['submitted', 'approved', 'finalized'].includes(autoRep.status?.toLowerCase())) {
            continue;
          }

          const fDate = item.flight_date ? item.flight_date.split('T')[0].split(' ')[0] : '';
          const airlineContracts = validContractsByAirline.get(item.airlineId);
          let hasActiveManualRows = false;
          if (airlineContracts) {
            for (let cIdx = 0; cIdx < airlineContracts.length; cIdx++) {
              const ac = airlineContracts[cIdx];
              if ((!ac.start || fDate >= ac.start) && (!ac.end || fDate <= ac.end)) {
                if (ac.contractrows && ac.contractrows.some((cr) => cr.applied_on?.includes('Manual'))) {
                  hasActiveManualRows = true;
                  break;
                }
              }
            }
          }
          if (!hasActiveManualRows) {
            continue;
          }
        }

        // 8. Hide completed filter
        if (hideCompleted) {
          const hasStatus = item.reports && item.reports.some((r) => r.type === contractType && Boolean(r.status));
          if (hasStatus) {
            continue;
          }
        }

        // 9. Airline filter
        if (airline) {
          if (contractTypes.length === 0) {
            continue;
          }
          if (item.airline?.code !== airline) {
            continue;
          }
        }

        // 10. Contract Type and Date window filter
        if (contractType) {
          const rejLog = item.reports ? item.reports.find((r) => r.status === 'Rejected') : null;
          const isRejForType = showRejectedFlights && rejLog && rejLog.type === contractType;

          if (!isRejForType) {
            const isDest = item.dest === stationCode;
            const timeRaw = isDest ? (item.act_arr || item.est_arr || item.schdl_arr) : (item.act_dept || item.est_dept || item.schdl_dept);
            const schRaw = isDest ? item.schdl_arr : item.schdl_dept;

            const timeFormatted = timeRaw ? dateTolocale(timeRaw, 'YYYY-MM-DD HH:mm:ss') : '';
            const schFormatted = schRaw ? dateTolocale(schRaw, 'YYYY-MM-DD HH:mm:ss') : '';

            const inTime = (timeFormatted >= fromStr && timeFormatted <= toStr);
            const inSch = (schFormatted >= fromStr && schFormatted <= toStr);

            if (!inTime && !inSch) {
              continue;
            }
          }
        }

        // 11. Active Contract Date Range check for this flight's airline
        if (hasMatchingContractType) {
          const ranges = validContractsByAirline.get(item.airlineId);
          if (!ranges || ranges.length === 0) {
            continue;
          }
          const fDate = item.flight_date ? item.flight_date.split('T')[0].split(' ')[0] : '';
          const hasValidDate = ranges.some((r) => (!r.start || fDate >= r.start) && (!r.end || fDate <= r.end));
          if (!hasValidDate) {
            continue;
          }
        } else if (contractType && Array.isArray(contractTypesList) && contractTypesList.length > 0) {
          continue;
        }
      }

      filteredData.push(item);
    }

    // 14. Sort by time with pre-computed sort keys (O(N) date conversions instead of O(N log N))
    const withSortKey = filteredData.map((item) => {
      const timeRaw = item.dest === stationCode
        ? (item.act_arr || item.est_arr || item.schdl_arr)
        : (item.act_dept || item.est_dept || item.schdl_dept);
      const timePart = timeRaw ? dateTolocale(timeRaw, 'HH:mm') : '00:00';
      return {
        item,
        key: `${item.flight_date || ''} ${timePart}`
      };
    });

    withSortKey.sort((a, b) => a.key.localeCompare(b.key));

    this.setState({
      filteredData: withSortKey.map((k) => k.item),
      anchorEl: null
    });
  };

  changeCheck = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type == 'checkbox' ? checked : value;

    let newFlightStatus = {
      ...this.state.flightStatus,
      [name]: newValue
    };

    if (name === 'manifest_uploaded' && newValue === true) {
      newFlightStatus.missing_ffm = false;
    } else if (name === 'missing_ffm' && newValue === true) {
      newFlightStatus.manifest_uploaded = false;
    }

    this.setState({ flightStatus: newFlightStatus }, () => {
      this.storeFilters();
      if (name === 'airline') {
        this.filterContractTypes();
      }
      // else if(name === 'submitted') {
      //   this.fetchFlights();
      // }
      else this.filterData();
    });
  };

  getTimeZone = (code) => {
    return airportTimezone?.find(function (airport) {
      return airport.code === code;
    })?.timezone;
  };

  dateTolocale = (date, format = 'YYYY-MM-DD', stn) => {
    if (!date) return null;
    const stn_code = stn;
    const tz = this.getTimeZone(stn_code);
    console.log(stn_code, tz);
    return moment.utc(date).tz(tz).format(format);
  };

  handleOpen = (modal, action, data = {}) => {
    // e.stopPropagation();
    this.setState({
      modal,
      action
    });
    if (action === 'add') {
      this.setState((prev) => ({
        flightFields: {
          ...prev.flightFields,
          airlineId: '',
          flight_no: '',
          flight_date: '',
          org: '',
          dest: '',
          schdl_dept: '',
          schdl_arr: '',
          ac_type: '',
          platform: ''
        },
        scheduleOrgDest: {
          org: null,
          dest: null
        },
      }));
    } else {
      this.setState({
        flightFields: { ...data, },
        scheduleOrgDest: {
          org: this.state.locationList.filter(c => c.iata_code === data.org)[0],
          dest: this.state.locationList.filter(c => c.iata_code === data.dest)[0]
        },
      }, () => {
        this.setState((prev) => ({
          flightFields: {
            ...prev.flightFields,
            schdl_dept: this.dateTolocale(data.schdl_dept, 'DD MMM YY HH:mm', prev.flightFields.org),
            schdl_arr: this.dateTolocale(data.schdl_arr, 'DD MMM YY HH:mm', prev.flightFields.dest),
          },
        }));
      }
      );
    }
  };

  onClose = () => {
    this.setState({
      modal: false,
      action: false,
    });
  };

  handleToggle = (e) => {
    let checked = e.target.value;
    // mounting the other view is heavy, so paint a loader before the switch commits
    this.setState({ viewSwitching: true }, () => {
      requestAnimationFrame(() => {
        this.setState({
          showTableView: checked,
          viewSwitching: false
        });
      });
    });
  };

  rowSelected = (flight) => {
    const userRole = cookies.get('role');
    if (userRole === 'GHA Agent') {
      this.props.history.push('/flight_folder/flight_report?id=' + flight?.id + '&org=' + flight?.row?.org + '&dest=' + flight?.row?.dest);
    } else {
      this.props.history.push('/flight_folder/notes?id=' + flight?.id + '&org=' + flight?.row?.org + '&dest=' + flight?.row?.dest);
    }
  };

  handlePopover = (anchorEl, data) => {
    this.setState({
      anchorEl,
      reportProps: data
    });
  };

  handlePopoverClose = () => {
    this.setState({ anchorEl: null });
  };

  handleFilterPopover = (filterAnchorEl) => {
    this.setState({ filterAnchorEl });
  };

  handleFilterPopoverClose = () => {
    this.setState({ filterAnchorEl: null });
  };

  handleAttachmentPopover = (modal, anchorEl, row) => {
    this.setState({
      modal,
      anchorEl,
      docs: row?.docs || [],
      docName: `${(row?.airline?.code || '') + (row?.flight_no || '')}` + (row?.flight_date ? `/${moment(row.flight_date).format(DateFormat).toUpperCase()}` : ''),
    });
  };

  storeFilters = () => {
    console.log('storeFilters');
    let filters = {
      searchFields: this.state.searchFields,
      flightFields: this.state.flightFields,
      flightStatus: this.state.flightStatus,
      showRejectedFlights: this.state.showRejectedFlights
    };
    // set expiry got 1 day.
    cookies.set('my_flights', filters, {
      path: '/',
      maxAge: 86400
    });
  };
  getFilters = () => {
    console.log('getFilters');
    let filters = cookies.get('my_flights');
    if (filters) {
      if (filters.searchFields) {
        this.setState({ searchFields: filters.searchFields });
      }
      if (filters.flightFields) {
        this.setState({ flightFields: filters.flightFields });
      }
      if (filters.flightStatus) {
        this.setState({
          flightStatus: {
            ...this.state.flightStatus,
            ...filters.flightStatus,
            pending: filters.flightStatus.pending !== undefined ? filters.flightStatus.pending : true
          }
        });
      }
      if (filters.showRejectedFlights !== undefined) {
        this.setState({ showRejectedFlights: filters.showRejectedFlights });
      }
    }
  };
  handleRejectedFlights = () => {
    this.setState((prev) => ({
      showRejectedFlights: !prev.showRejectedFlights,
      flightStatus: {
        ...prev.flightStatus,
        hideCompleted: false
      }
    }), () => {
      this.storeFilters();
      this.filterData();
    });
  };

  resetAdvancedFilters = () => {
    this.setState((prev) => ({
      flightStatus: {
        ...prev.flightStatus,
        submitted: true,
        no_op: true,
        pending: true,
        missing_ffm: false,
        manifest_uploaded: false,
        manual_updated_auto: false,
        updated_auto: false
      },
      showRejectedFlights: true
    }), () => {
      this.storeFilters();
      this.filterData();
    });
  };

  render() {
    return (
      <>
        <MyFlights
          modal={this.state.modal}
          action={this.state.action}
          handleOpen={this.handleOpen}
          onClose={this.onClose}
          flightList={this.state.filteredData}
          onFilterMain={this.onFilterMain}
          fetchFlights={this.fetchFlights}
          onChange={this.onChange}
          changeDateTime={this.changeDateAndTime}
          flightFields={this.state.flightFields}
          flightErrors={this.state.flightErrors}
          searchFields={this.state.searchFields}
          airlines={this.state.airline}
          addFlight={this.addFlight}
          editFlight={this.editFlight}
          flightData={this.state.flightData}
          stations={this.props.stations}
          handleDelete={this.handleDelete}
          stationCode={this.station_code}
          openFlightsFolder={this.openFlightsFolder}
          flightDetails={this.state.flightDetails}
          flightID={this.state.flightID}
          showflightDetails={this.state.showflightDetails}
          changeCheck={this.changeCheck}
          flightStatus={this.state.flightStatus}
          searchActive={Boolean(this.state.search)}
          showTableView={this.state.showTableView}
          handleToggle={this.handleToggle}
          rowSelected={this.rowSelected}
          locationList={this.state.locationList}
          scheduleOrgDest={this.state.scheduleOrgDest}
          handlePopover={this.handlePopover}
          handlePopoverClose={this.handlePopoverClose}
          anchorEl={this.state.anchorEl}
          filterAnchorEl={this.state.filterAnchorEl}
          handleFilterPopover={this.handleFilterPopover}
          handleFilterPopoverClose={this.handleFilterPopoverClose}
          reportProps={this.state.reportProps}
          userContractTypes={this.state.userContractTypes}
          contractTypes={this.state.contractTypes}
          showRejectedFlights={this.state.showRejectedFlights}
          handleRejectedFlights={this.handleRejectedFlights}
          resetAdvancedFilters={this.resetAdvancedFilters}
          getFreport={this.getFreport}
          expandedRows={this.state.expandedRows}
          handleRowExpand={this.handleRowExpand}
          handleAttachmentPopover={this.handleAttachmentPopover}
          alert={this.state.alert}
          loading={this.state.loading}
          contractsLoading={this.state.contractsLoading}
          viewSwitching={this.state.viewSwitching}
        />

        <ConfirmModalContainer />
        {this.state.modal === 'attached_docs' &&
          <AttachmentContainer
            handlePopover={this.handleAttachmentPopover}
            anchorEl={this.state.anchorEl}
            modal={this.state.modal}
            type={'FLIGHT'}
            docs={this.state.docs}
            docName={this.state.docName}
          />
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { stations: state.stations };
};

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyFlightsContainer);
